import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/class/base"

const sysClass = {
  classListPage(pageSize, limit, keyWord) {
    return axios.get(pre + `/classListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
        }
    });
  },
  classInfo(id) {
    return axios.get(pre + `/classInfo`, {params: {id: id}});
  },
  classSave(params) {
    return axios.post(pre + `/classSave`, qs.stringify(params));
  },
  classDelete(id) {
    return axios.delete(pre + `/classDelete`,  {params: {id: id}});
  },
}
export default sysClass;



// WEBPACK FOOTER //
// ./src/api/config/sysClass.js